import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { listAddOnProductsCart } from "../../core/addOnDiscount.core";
import { AddOnDiscountGroup } from "../../types/cart";
import { useCartId } from "./useCartId.hook";

export function useAddOnProducts(productIds: string[] | null | undefined) {
  const router = useRouter();
  const cartId = useCartId();

  return useQuery<AddOnDiscountGroup[]>({
    queryKey: ["addOnProducts", productIds, cartId, router.locale],
    queryFn: () => listAddOnProductsCart(productIds!, cartId!),
    enabled: !!productIds && productIds.length > 0 && router.isReady && !!cartId,
  });
}
